import React from "react";
import styles from "./ChipButton.module.scss";

const ChipButton = ({ label, selected, onClick, disabled, size, className }) => {
  return (
    <button
      type="button"
      className={`${styles.chip} ${className || ""}`}
      data-selected={!!selected}
      data-disabled={!!disabled}
      data-size={size || "sm"}
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </button>
  );
};

export default ChipButton;
